import {useEffect} from "react";
import {App} from "antd";
import {setAntdFeedback} from "./antdFeedback";

/**
 * Publishes antd's context-aware message/notification/modal instances to `antdFeedback`,
 * so plain callbacks across the app can raise themed toasts without being hooks themselves.
 * Renders nothing; must sit inside `<App>`.
 */
export function AntdFeedbackBridge() {
  const {message, notification, modal} = App.useApp();

  useEffect(() => {
    setAntdFeedback({message, notification, modal});
  }, [message, notification, modal]);

  return null;
}

export default AntdFeedbackBridge;
